import { checkReauthRequiredFromAxiosError } from './error';

/**
 * Ory Kratos API呼び出しで403エラーが発生した場合、再認証が必要な場合は
 * GlobalAuthModalを表示し、再認証成功後に元の関数を再実行します。
 *
 * @param apiCall - 実行するAPI呼び出し関数
 * @returns API呼び出しの結果
 *
 * @example
 * ```ts
 * const result = await handleOryErrorWithReauth(async () => {
 *   return await oryKratosClient.getApi().updateSettingsFlow({ flow: flowId, updateSettingsFlowBody: body });
 * });
 * ```
 */
export async function handleOryErrorWithReauth<T>(apiCall: () => Promise<T>): Promise<T> {
  try {
    return await apiCall();
  } catch (error) {
    const authType = await checkReauthRequiredFromAxiosError(error);
    if (authType) {
      // 再認証が必要な場合、GlobalAuthModalを開く
      const {
        useGlobalAuthModal
      } = await import('@/features/auth/components/GlobalAuthModal');
      await useGlobalAuthModal.getState().openModal(authType);

      // 再認証成功後、元のAPI呼び出しを再試行
      return await apiCall();
    }

    // 再認証が不要な場合は、エラーをそのまま再スロー
    throw error;
  }
}